import { makeStyles } from 'tss-react/mui';
import { useSidebarOpenState } from '@backstage/core-components';

const useStyles = makeStyles()({
  container: {
    textAlign: 'center',
    margin: 'auto',
    marginBottom: '2em',
    '& span': {
      display: 'block',
      margin: '0 auto',
      color: 'white',
    },
  },
  title: {
    fontSize: '1.25em',
  },
  subTitle: {
    paddingTop: '0.5rem',
    fontSize: '0.75em',
  },
});

export const AppTitle = () => {
  const { classes } = useStyles();
  const { isOpen } = useSidebarOpenState();

  return isOpen ? (
    <div className={classes.container}>
      <span className={classes.subTitle}>CONFIDENTIAL</span>
    </div>
  ) : null;
};
